module.exports = __webpack_public_path__ + "static/media/koryu_name_00049.c18db26f.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/koryu_name_00049.png
// module id = 211
// module chunks = 0